import { Heading } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { vars } from '../../utils/appConfig'
import { getEnvs } from '../../utils/env'
import { LanguageSelector } from '../LanguageSelector/LanguageSelector'

export const AppInfo = (): JSX.Element => {
  const { t } = useTranslation()
  const feVersion = process.env.REACT_APP_GIT_VERSION
  const feGitSha = process.env.REACT_APP_GIT_SHA
  const { backendAppVersion, env } = getEnvs()

  return (
    <>
      <Heading headingLevel="2" headingLevelStyle="3" noTopMargin>
        {vars.appName}
      </Heading>
      <p>
        {env && (
          <>
            <b>Environment:</b> {env}
          </>
        )}
        {feVersion && feGitSha && (
          <>
            <br />
            <b>Frontend:</b> {`${feVersion} (${feGitSha})`}
          </>
        )}
        {backendAppVersion && (
          <>
            <br />
            <b>Backend:</b> {backendAppVersion}
          </>
        )}
      </p>

      <LanguageSelector label={t('Interface language')} />
    </>
  )
}
